import { render } from "./CountryView.vue?vue&type=template&id=6cf70f15&scoped=true"
import script from "./CountryView.vue?vue&type=script&lang=js"
export * from "./CountryView.vue?vue&type=script&lang=js"

import "./CountryView.vue?vue&type=style&index=0&id=6cf70f15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf70f15"]])

export default __exports__